import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import SiteLayout from "src/components/layout"
import SEO from "src/components/seo"
/*import Safe from "react-safe"*/
/*import Reviews from "src/components/reviews"*/
/*import { Link } from "gatsby"*/
import { TwitchEmbed } from 'react-twitch-embed';
import { Layout, Carousel } from "antd";
import "src/css/antd-layout.css"
/*import { TwitchEmbed, TwitchChat, TwitchClip, TwitchPlayer } from 'react-twitch-embed';*/
// import CustomDataTable from "src/components/CustomDataTable"

const { Header, Footer, Sider, Content } = Layout;


class IndexNewsPost extends React.Component {

  render() {

    const { data } = this.props;
    console.log("datalogNews", data);

    return (

      <React.Fragment>

        <div className="row product-main raid posts">
          {data.data.allNews.nodes.map(items => (
            <div className="Catalogue__item col-sm-12 col-md-6 col-lg-4" key={items.id}>
              <div className="details_List">

                <Link to={`/news/${items.slug}`}>

                  { items.featured_image ?
                     <img
                      src={items.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${items.featured_image[0].id}.${items.featured_image[0].extension}` : ""}
                      className="post-image"
                      alt="Click here to find out more!"
                      title="Click here to find out more!"
                     />
                    :
                     <div className="no-image">No Image</div>
                  }

                </Link>


                  <div className="details_inner">
                  <Link to={`/news/${items.slug}`}>
                    {/* <Link to={`/news/${items.slug}`}><span className="title" dangerouslySetInnerHTML={{ __html: items.title}} /></Link> */}
                    <h2 className="title">{items.seoTitle}</h2>
                    {/* <span className="title">Chofly Elite v2.0<br /> is Live!</span> */}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

      </React.Fragment>
    );
  }
}

const IndexNewsPage = data => (

  <SiteLayout>
    <SEO
    title="Chofly Elite"
    ogTitle="Chofly Elite"
    ogURL="https://choflyelite-legacy.netlify.com"
    ogDescription="Gaming Content Producer | Currently focussed on RAID Shadow Legends | Plarium Moderator | Twitch Streamer | YouTube Content Creator | Chofly Elite Community Discord"
    ogImage={data.data.home.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.home.featured_image[0].id}.${data.data.home.featured_image[0].extension}` : ""}
    ogImageSecure={data.data.home.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.home.featured_image[0].id}.${data.data.home.featured_image[0].extension}` : ""}
    keywords={['Chofly Elite', 'ChoseN', 'Raid', 'Raid Shadow Legends', 'Twitch Streamer', 'YouTuber', 'Content Creator', 'YouTube Content Creator', 'Plarium Moderator',]}
    />
    <div className="container">
      <div className="container-content-wrap">
        <div className="text-center"><h1>Chofly News</h1></div>
        <IndexNewsPost data={data} />
      </div>
    </div>
  </SiteLayout>
)

export default IndexNewsPage

export const query = graphql`
    query allNewsPageQuery {

      allNews(filter: {publish: {eq: true}}) {
          nodes {
            id
            slug
            title
            titleClass
            seoTitle
            content
            featured_image {
              url
              id
              extension
            }
            publish
          }
        }



        home {
          heading
          content
          featured_image {
            id
            fileName
            extension
          }
          game_logos {
            extension
            fileName
            url
            size
            id
            height
            width
            type
          }
          game_logo_width
          game_logo_margin
        }

  }

`


